import React, { useRef } from 'react';
import { Trail } from '../../../../models/Trail';
import { checkImage } from '../../../componentUtils';
import {
	BookmarkContainer,
	BookmarkImg,
	BookmarkImgContainer,
	BookmarkInner,
	BookmarkMeta,
	BookmarkTextContainer,
	BookmarkTitle,
} from '../bookmarkStyles';
import { TrailHelper } from '../../../../models/helpers/Helpers';
import { useHistory } from 'react-router';
import {
	IonIcon,
	IonItemOption,
	IonItemOptions,
	IonItemSliding,
} from '@ionic/react';
import { trash } from 'ionicons/icons';
import {
	BOOKMARK_DEL_TRAIL,
	BookmarkReducerAction,
} from '../../../../state/bookmarksSlice';
import { useAppDispatch, useAppSelector } from '../../../../state/hooks';
import { createAnimation } from '@ionic/react';
import { shallowEqual } from 'react-redux';

type TrailBookmarkProps = {
	trail: Trail;
};
const TrailBookmark: React.FC<TrailBookmarkProps> = ({ trail }) => {
	const dispatch = useAppDispatch();
	const user_prefs = useAppSelector(
		(state) => state.prefs,
		shallowEqual,
	);
	const history = useHistory();

	const gotoTrailPage = () => {
		history.push('/trail/' + trail.id);
	};

	const container = useRef(null);
	const fadeOutKeyframes = [
		{ offset: 0, opacity: 1 },
		{ offset: 1, opacity: 0 },
	];
	const playAnimation = () => {
		if (container.current !== null) {
			const animation = createAnimation()
				.addElement(container.current)
				.duration(350)
				.keyframes(fadeOutKeyframes)
				.onFinish(removeBookmark);
			animation.play();
		}
	};
	const handleSlide = async (event: any) => {
		const ratio = await event.target.getSlidingRatio();
		if (ratio >= 4) {
			await event.target.open();
			playAnimation();
		}
	};
	const removeBookmark = () => {
		console.log('removing', trail.id, trail.title);
		dispatch({
			type: BOOKMARK_DEL_TRAIL,
			payload: {
				action_id: trail.id,
			},
		} as BookmarkReducerAction);
	};
	return (
		<BookmarkContainer ref={container}>
			<IonItemSliding onIonDrag={handleSlide}>
				<BookmarkInner
					onClick={() => {
						gotoTrailPage();
					}}>
					<BookmarkImgContainer>
						<BookmarkImg src={checkImage(trail.image)} />
					</BookmarkImgContainer>

					<BookmarkTextContainer>
						<BookmarkTitle>{trail.title}</BookmarkTitle>
						<BookmarkMeta>
							{TrailHelper.generateMetaString(
								trail,
								user_prefs.preferred_dist_units,
							)}
						</BookmarkMeta>
					</BookmarkTextContainer>
				</BookmarkInner>
				<IonItemOptions>
					<IonItemOption
						color="warning"
						expandable
						onClick={() => {
							playAnimation();
						}}>
						<IonIcon slot="icon-only" icon={trash}></IonIcon>
					</IonItemOption>
				</IonItemOptions>
			</IonItemSliding>
		</BookmarkContainer>
	);
};

export default TrailBookmark;
